import { MessagesScreen } from '../messages/MessagesScreen';

/** Klijentov popis razgovora i prozor razgovora — `/poruke` i `/poruke/:conversationId`. */
export function Messages() {
  return <MessagesScreen basePath="/poruke" />;
}
